import React from 'react';
import '../../App.css';
import Sidebar from './sidebar';
import Categories from './masters/categories';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Routes, Route, Navigate } from 'react-router-dom';
import Items from './masters/items';
import ItemTypes from './masters/itemtypes';
import Media from './masters/media';
import Account from './administrator/account';
import AccountsList from './administrator/accountlist';
import Programs from './masters/programs';
// import Units from './masters/residential';
import ContactDetails from './masters/contact';
import Residential from './masters/residential';
import ProgramUnits from './masters/programunits';
import PublicHolidays from './masters/publicHolidays';
import Seasons from './masters/seasons';
import Guests from './administrator/guests';
import Filters from './masters/filters'

import BookingCalendar from './operations/bookingCalendar'
import Bookings from './operations/booking2';
import Users from './users/users'
import Navbar from './operations/adminNavbar';
import Groceries from './masters/groceries';
import GeneralPreferences from './masters/generalPreferences';
import Orders from './operations/orders';
import BookingsList from './operations/bookingsList';
import OrderList from './operations/orderList';
import Report from './operations/report';

const Dashboard = () => {
  return (
  
    <Container fluid className='m-0 p-0'>
      <Row className='g-0'>
        <Col xs={2}><Sidebar /></Col>
        <Col xs={10}>
        <Navbar/>
          <Routes>
            {/* Index route for /admin to redirect to categories */}
            <Route index element={<Navigate to="categories" />} />
            
            {/* Specific routes */}
            <Route path='itemtypes' element={<ItemTypes />} />
            <Route path="categories" element={<Categories />} />
            <Route path="items" element={<Items />} />
            <Route path='media' element={<Media />} />
            <Route path='residential' element={<Residential />}/>
            <Route path='accounts' element={<Account />}/>
            <Route path='accountlist' element={<AccountsList />}/>
            <Route path='programs' element={<Programs />}/>
            <Route path="programunits" element={<ProgramUnits />} />
            <Route path='contact' element={<ContactDetails/> }/>
            <Route path='publicholidays' element={<PublicHolidays/> }/>
            <Route path='seasons' element={<Seasons/> }/>
            <Route path='guests' element={<Guests/> }/>
            <Route path='bookingcalendar' element={<BookingCalendar/> }/>
            <Route path='booking' element={<Bookings />} />
            <Route path= 'users' element={<Users />} />
            <Route path= 'groceries' element={<Groceries />} />
            <Route path='orders' element={<Orders />} /> 
            <Route path='filters' element={<Filters />} /> 
            <Route path='generalpreferences' element={<GeneralPreferences />} /> 
            <Route path='bookingslist' element={<BookingsList />} />
            <Route path='orderlist' element={<OrderList />} />
            <Route path='report' element={<Report />} />
          </Routes>
        </Col>
      </Row>
    </Container>
     
  );
};

export default Dashboard;
